import AuthenticationContext from 'adal-angular/lib/adal.js'
import service from '@/utils/request'
import store from '@/store'

const config = {
  tenant: 'cfc851ec-2a7f-49b1-b359-ef4fdf297135',
  clientId: 'f44ceff0-6f7f-4e33-9a74-4766de7095da', // prod client id
  // clientId: '148768a6-ef94-46ee-9a6a-13e957e8f707', // dev client id
  // redirectUri: 'http://localhost:8080/', // dev redirect
  // postLogoutRedirectUri: 'http://localhost:8080/login',
  redirectUri: 'https://dkl-dsms.dci-one.de', // prod client id
  cacheLocation: 'localStorage'
}

const graphResource = 'https://graph.windows.com/00000002-0000-0000-c000-000000000000'
const crmResource = 'https://deutsche-datenschutzkanzlei.crm4.dynamics.com/'

export default {
  authenticationContext: null,
  /**
   * @return {Promise}
   */
  initialize() {
    this.authenticationContext = new AuthenticationContext(config)

    return new Promise((resolve, reject) => {
      if (this.authenticationContext.isCallback(window.location.hash) || window.self !== window.top) {
        // redirect to the location specified in the url params.
        this.authenticationContext.handleWindowCallback()
      } else {
        // try pull the user out of local storage
        // const user = this.authenticationContext.getCachedUser()

        if (this.isAuthenticated()) {
          // console.log('user exists')
          resolve()
        } else {
          // no user at all - go sign in.
          this.authenticationContext.login()
        }
      }
    })
  },
  /**
   * @return {Promise.<String>} A promise that resolves to an ADAL token for resource access
   */
  acquireToken(resource) {
    return new Promise((resolve, reject) => {
      if (this.authenticationContext === null) this.initialize()
      this.authenticationContext.acquireToken(resource, (err, token) => {
        if (err) {
          const errCode = err.split(':')[0]
          switch (errCode) {
            case 'AADSTS50058': // Need to prompt for user sign in
              this.authenticationContext.login()
              break
            case 'AADSTS65001': // Token is invalid; grab a new one
              this.authenticationContext.acquireTokenRedirect(resource)
              break
            case 'AADSTS16000': // No Access
            default:
              // Need a pop-up forcing a login
              this.authenticationContext.login()
              break
          }
          return reject(new Error('Failed to acquire Toke'))
        }
        return resolve(token)
      })
    })
  },
  /**
   * Test
   */
  acquireCRMTokenCallback(resource, callback) {
    return new Promise((resolve, reject) => {
      if (this.authenticationContext === null) this.initialize()
      this.authenticationContext.acquireToken(resource, callback)
    })
  },
  /**
  * acquire token for Crm 365
   */
  acquireCRMToken() {
    this.authenticationContext = new AuthenticationContext(config)
    return new Promise((resolve, reject) => {
      this.authenticationContext.acquireToken(crmResource, (err, token) => {
        if (err) {
          const errCode = err.split(':')[0]
          console.log(errCode)
          switch (errCode) {
            case 'AADSTS50058': // Need to prompt for user sign in
              this.authenticationContext.login()
              break
            case 'AADSTS65001': // Token is invalid; grab a new one
              this.authenticationContext.acquireTokenRedirect(crmResource)
              break
            case 'AADSTS16000': // No Access
            default:
              // Need a pop-up forcing a login
              this.authenticationContext.login()
              break
          }
          return reject(new Error('Failed to acquire Toke'))
        }
        return resolve(token)
      })
    })
  },
  /**
   * Issue an interactive authentication request for the current user and the api resource.
   */
  acquireTokenRedirect() {
    if (this.authenticationContext === null) { this.authenticationContext = new AuthenticationContext(config) }
    this.authenticationContext.acquireTokenRedirect(graphResource)
  },
  /**
   * Issue an interactive authentication request for the current user and the api resource.
   */
  acquireCRMTokenRedirect() {
    if (this.authenticationContext === null) { this.authenticationContext = new AuthenticationContext(config) }
    this.authenticationContext.acquireTokenRedirect(crmResource)
  },
  /**
   * @return {Boolean} Indicates if there is a valid, non-expired access token present in localStorage.
   */
  isAuthenticated() {
    // getCachedToken will only return a valid, non-expired token.
    const authenticated = !!this.authenticationContext.getCachedToken(config.clientId)
    const user = this.authenticationContext.getCachedUser()
    return authenticated && user
  },
  /**
   * @return An ADAL user profile object.
   */
  getUserProfile() {
    return this.authenticationContext.getCachedUser().profile
  },
  signIn() {
    if (this.authenticationContext === null) {
      this.authenticationContext = new AuthenticationContext(config)
      this.authenticationContext.login()
    } else {
      this.authenticationContext.login()
    }
    const user = this.getUserProfile()
    store.commit('SET_NAME', user.name)
    store.commit('SET_EMAIL', user.unique_name)
    store.commit('SET_MICROSOFT_ID', user.oid)
    const query_string = '?microsoft_id=' + user.oid + '&email=' + user.unique_name +
      '&first_name=' + user.given_name + '&last_name=' + user.family_name
    // const that = this
    service.request({
      url: encodeURI('login/' + query_string),
      method: 'GET',
      responseType: 'json'
    }).then(function(response) {
      store.commit('SET_ID', response.data.id)
    }).catch(function(err) {
      console.log(err)
    })
  },
  signOut() {
    this.authenticationContext.logOut()
    this.authenticationContext.clearCache()
  }
}
